import React, { useState, useEffect, useMemo } from 'react';
import {
  Widget,
  GridView,
  SimpleView,
  Table,
  Button,
  ButtonDelete,
  MasterDetailForm,
  FormInput,
  notification,
  FormTextArea,
  Icon
} from '@digital/ui';
import FiltrosPcs from './FiltrosPcs';
import { Collapse, Icon as IconAntD, Input, Tooltip } from 'antd';
import { getAllCrfProjetoContaContabilCc, ProjetoCrfContaContabilCc } from '@app/api/crf/Crfprojeto';
import { ChangeEvent } from 'react';
import {
  Filter,
  RequisitadoOcData,
  getAllRequisitadoOcData,

  DistribuicaoRequisitado,
  RequisitadoAno,
  atualizarValorRequisitadoAno,
  deleteRequisitadoAno,
  adicionarLinhaItemRateavelRequisitadoAno,
  concluirRateioOcRc,
  getAllRequisitadoAnoOc
} from '@app/api/crf/crfRequisitadoOc';
import {
  obterNarativaPorCrfContaContabilCcRequisicaoCompraSeqId,
} from '@app/api/crf/crfContratoPcs';
import { Notifications } from '@app/api/api';
import Narativa from '@app/components/Narativa';
import { hasPermission } from '@app/helpers/permissions';



const RequisitadoOc = () => {
  const { Panel } = Collapse;

  const [resultPesquisa, setResultConsult] = useState<RequisitadoOcData[]>();
  const [resultadoSelecionado, setResultadoSelecionado] = useState<string>();
  const [distribuicaoItemSelecionado, setdistribuicaoItemSelecionado] = useState<RequisitadoAno>();
  const [resultContratadoAno, setResultContratadoAno] = useState<RequisitadoAno[]>();
  const [resultDistribuicao, setDistribuicao] = useState<DistribuicaoRequisitado>();
  const [selectionOrdemInvestimento, setSelectionOrdemInvestimento] = useState<ProjetoCrfContaContabilCc>();
  const [resultProjetoOrdemInvestimento, setProjetoOrdemInvestimento] = useState<ProjetoCrfContaContabilCc[]>();
  const [imputTextoNarativa, setImputTextoNarativa] = useState<string>('');
  const [imputProjeto, setImputProjeto] = useState<string>('');
  const [imputPacoteOi, setImputPacoteOi] = useState<string>('');
  const [editavel, setEditavel] = useState<boolean>(false);
  const [idEdit, setidEdit] = useState<string>('');
  const [quantidadeAnoEdit, setQuantidadeAnoEdit] = useState<string>('');
  const [enableBtnsRateio, setEnableBtnsRateio] = useState<boolean>(false);
  const [displayWidgetNovaLinha, setDisplayWidgetNovaLinha] = useState({ display: 'none' });
  const [displayWidgetResultado, setDisplayWidgetResultado] = useState({ display: 'none' });
  const [displayWidgetTabelaDistribuicao, setDisplayWidgetTabelaDistribuicao] = useState({ display: 'none' });
  const [btnAdcionarLinhaSelecionado, setBtnAdcionarLinhaSelecionada] = useState<boolean>(true);


  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      if (selectedRows) {
        setResultadoSelecionado(selectedRowKeys);
      } else {
        setResultadoSelecionado('');
      }
    },
    getCheckboxProps: (record: { name: any; }) => (
      {
        disabled: record.name === 'Disabled User',
        name: record.name,
      }),
    selectedRowKeys: resultadoSelecionado,
    type: 'radio'
  };

  const rowSelectionTableDistribuicao = {
    onChange: (selectedRowKeys: string, selectedRows: RequisitadoAno[]) => {
      if (selectedRowKeys) {
        setdistribuicaoItemSelecionado(selectedRows[0]);
      } else {
        setdistribuicaoItemSelecionado({} as RequisitadoAno);
      }
    },
    getCheckboxProps: (record: { name: any; }) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    selectedRowKeys: distribuicaoItemSelecionado != undefined ? distribuicaoItemSelecionado.crfContaContabilCcRequisicaoCompraSeqId : '',
    type: 'radio'
  };

  const rowSelectionOrdemInvestimento = {
    onChange: (selectedRowKeys: string, selectedRows: ProjetoCrfContaContabilCc[]) => {
      if (selectedRows) {
        setSelectionOrdemInvestimento(selectedRows[0]);
      } else {
        setSelectionOrdemInvestimento({} as ProjetoCrfContaContabilCc);
      }
    },
    getCheckboxProps: (record: { name: any; }) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    selectedRowKeys: selectionOrdemInvestimento != undefined ? selectionOrdemInvestimento.crfContaContabilCcId : '',
    type: 'radio'
  };

  const handleFilter = (values: Filter) => {
    getAllRequisitadoOcData(values).then(data => {
      if (data) {
        limparCamposTela();
        setDisplayWidgetResultado({ display: 'block' });
        setResultConsult(data as RequisitadoOcData[]);
        setdistribuicaoItemSelecionado({} as RequisitadoAno);
      }
    });
  };

  const iniciarValores = () => {
    setProjetoOrdemInvestimento([]);
    setResultContratadoAno([]);
    setdistribuicaoItemSelecionado({} as RequisitadoAno);
    setDisplayWidgetNovaLinha({ display: 'none' });
    setEnableBtnsRateio(false);
    setImputTextoNarativa('');
    setDisplayWidgetTabelaDistribuicao({ display: 'none' });
    setSelectionOrdemInvestimento({} as ProjetoCrfContaContabilCc);
    setBtnAdcionarLinhaSelecionada(false);
  }

  const atualizarTabela = useMemo(() => {
    iniciarValores();
  }, [resultadoSelecionado]);

  const limparCamposTela = () => {
    setResultConsult([]);
    setResultadoSelecionado('');
    iniciarValores();
    setDisplayWidgetResultado({ display: 'none' });
  };


  const cancelar = () => {
    setEditavel(false);
    setidEdit('');
  };

  const eventoClickImput = (event: ChangeEvent<HTMLInputElement>, recorder: RequisitadoAno, quantidadeAno: string) => {
    setEditavel(true);
    setidEdit(recorder.crfContaContabilCcRequisicaoCompraSeqId);
    setQuantidadeAnoEdit(quantidadeAno);
  };

  const salvar = (
    recorder: RequisitadoAno,
    event: ChangeEvent<HTMLInputElement>,
    valorAlterado: string,
    ano: string,
  ) => {
    atualizarValorRequisitadoAno(
      recorder.crfContaContabilCcRequisicaoCompraSeqId,
      valorAlterado,
      ano,
    ).then(data => {
      AtualizarTablelaContratoAno();
      setEditavel(false);
      setidEdit('');
    });
  };

  const columsDistribuicaoItem = useMemo(() => {
    const colluns = [];

    colluns.push({
      title: 'CC / CONTA CONTÁBIL',
      key: 'PACOTE',
      children: [
        {
          title: 'CENTRO DE CUSTO',
          dataIndex: 'pacoteProjeto',
        },
        {
          title: 'CONTA CONTÁBIL',
          dataIndex: 'pacotePctOi',
        },
      ],
    });

    colluns.push({
      title: 'REQUISIÇÃO DE COMPRA',
      key: 'REQUISICAODECOMPRA',
      children: [
        {
          title: 'Numero',
          dataIndex: 'requisicaoCompraNumero',

        },
        {
          title: 'SEQ',
          dataIndex: 'requisicaoCompraSeq',

        },
        {
          title: 'PREÇO UNITÁRIO',
          dataIndex: 'requisicaoCompraPrecoUnitarioFormatado',

        },
        {
          title: 'QTD',
          dataIndex: 'quantidadeFormatado',

        },
        {
          title: 'VALOR',
          dataIndex: 'requisicaoCompraValorTotalFormatado',

        },
        {
          title: 'OC',
          dataIndex: 'requisicaoCompraOc',

        },
      ],
    });

    if (resultDistribuicao) {
      const distrubuicao = resultDistribuicao as DistribuicaoRequisitado;
      let colunasAnos:
        {
          title: string;
          dataIndex: string;
          width: string;
          children: (
            {
              title: string;
              dataIndex: string; key:
              string; render: (text: any, record: any, index: any) => JSX.Element;
            } | { title: string; dataIndex: string; key: string; render?: undefined; })[];
        }[] = [];

      distrubuicao.anos.map(ano => {
        colluns.push({
          title: `Rateio`,
          dataIndex: `${ano}`,
          width: '',
          children: [
            {
              title: 'QTD',
              dataIndex: `quantidade${ano}`,
              key: `quantidade${ano}`,
              render: (text, record, index) => {
                if (hasPermission(['MODULO_REQUISITADO_ALTERAR_INCLUIR_DELETAR'])) {
                  if (
                    editavel &&
                    idEdit === record.crfContaContabilCcRequisicaoCompraSeqId &&
                    quantidadeAnoEdit === `${record.crfContaContabilCcRequisicaoCompraSeqId}quantidade${ano}`
                  ) {
                    return (
                      <Input
                        id={`${record.crfContaContabilCcRequisicaoCompraSeqId}quantidade${ano}`}
                        name={`${record.crfContaContabilCcRequisicaoCompraSeqId}quantidade${ano}`}
                        onBlur={() => {
                          cancelar();
                        }}
                        onPressEnter={e => {
                          const evento = e as unknown as ChangeEvent<HTMLInputElement>;
                          salvar(record, evento, record[`quantidade${ano}`], `${ano}`);
                        }}
                        defaultValue={record[`quantidadeInicial${ano}`]}
                        onChange={e => {
                          record[`quantidade${ano}`] = e.target.value;
                        }}
                      />
                    );
                  } else {
                    return (
                      <div
                        className="editable-cell-value-wrap"
                        style={{ paddingRight: 24 }}
                        onClick={e => {
                          const evento = e as unknown as ChangeEvent<HTMLInputElement>;
                          eventoClickImput(evento, record, `${record.crfContaContabilCcRequisicaoCompraSeqId}quantidade${ano}`)
                        }
                        }>
                        {<> {record[`quantidadeInicial${ano}`]} </>}
                      </div>
                    );
                  }

                } else {
                  return <> {record[`quantidadeInicial${ano}`]} </>
                }
              },
            },
            {
              title: 'Valor',
              dataIndex: `valorFormatado${ano}`,
              key: `valorFormatado${ano}`,
            },
          ],
        });
      });
    }

    return colluns;
  }, [resultDistribuicao, editavel, idEdit]);

  const columsRequisicaoCompraSeq = [
    {
      title: 'CC / CONTA CONTÁBIL',
      key: 'pacoteCodigo',
      children: [
        {
          title: 'N',
          dataIndex: 'row',
          width: '1%',
        },
        {
          title: 'Centro de Custo',
          dataIndex: 'projetoNumero',
          width: '',
        },
        {
          title: 'Conta Contábil',
          dataIndex: 'contaContabilCodigo',
          width: '',
        },
        {
          title: 'Título Conta Contábil',
          dataIndex: 'contaContabilNome',
          width: '',
        },
        {
          title: 'Agrupador',
          dataIndex: 'agrupador',
          width: '',
        },
        {
          title: 'Projeto',
          dataIndex: 'projetoNome',
          width: '',
        },
      ],
    },
    {
      title: 'RC',
      key: 'rc',
      children: [
        {
          title: 'NÚMERO	',
          dataIndex: 'rcNumero',
          width: '',
        },
        {
          title: 'SEQ',
          dataIndex: 'rcSeq',
          width: '',
        },
        {
          title: 'STATUS',
          dataIndex: 'rcStatus',
          width: '',
        },
      ],
    },
    {
      title: 'OC',
      key: 'oc',
      children: [
        {
          title: 'Numero',
          dataIndex: 'ocNumero',
          width: '',
        },
        {
          title: 'Data',
          dataIndex: 'ocData',
          width: '',
        },
      ],
    }
  ];

  const columsNovasLinhas = [
    {
      title: 'PROJETO',
      dataIndex: 'numero',
      width: '10%',
    },
    {
      title: 'AGRUPADOR',
      dataIndex: 'codigoPacote',
      width: '10%',
    },
    {
      title: 'CONTA CONTÁBIL',
      dataIndex: 'crfContaContabilNumero',
      width: '10%',
    },
    {
      title: 'DESCRIÇÃO DA CONTA CONTÁBIL',
      dataIndex: 'nome',
    },
  ];

  const deletarLinhaRateio = async (ordemInvestimentoRequisicaoCompraSeqId: string) => {
    const result = await deleteRequisitadoAno(ordemInvestimentoRequisicaoCompraSeqId);
    if (result) {
      if (result.valid) {
        notification.success('Item removido com sucesso.');
        AtualizarTablelaContratoAno();
      } else {
        if (result.invalid) {
          if (result.notifications.length > 0) {
            result.notifications.map(mensagem => {
              const mensagemNotificacao = mensagem as Notifications;
              notification.error(mensagemNotificacao.message);
            })
          }
        }
      }
    }
  };

  const btnsDistribuicaoItem = useMemo(() => {
    const actions = [];

    if (hasPermission(['MODULO_REQUISITADO_ALTERAR_INCLUIR_DELETAR'])) {

      actions.push(
        <ButtonDelete
          type="link"
          confirm="Deseja realmente excluir este registro?"
          title="EXCLUIR LINHA"
          icon="data-delete_row"
          okText="Confirmar"
          className="btn-delete-without-text"
          disabled={enableBtnsRateio}
          onClick={() => {
            if (distribuicaoItemSelecionado && distribuicaoItemSelecionado.crfContaContabilCcRequisicaoCompraSeqId) {
              deletarLinhaRateio(distribuicaoItemSelecionado.crfContaContabilCcRequisicaoCompraSeqId);
            } else {
              notification.error('Você deve selecionar um item');
            }
          }}
        />,
      );

      actions.push(
        <Button
          type="link"
          title="ADICIONAR LINHA"
          disabled={enableBtnsRateio}
          icon="data-add_row"
          onClick={() => {
            setDisplayWidgetNovaLinha({ display: 'block' });
            setEnableBtnsRateio(true);
          }}
        />,
      );

      actions.push(
        <Button
          type="primary"
          Icon="messaging-ok"
          title="Concluir Rateio"
          disabled={enableBtnsRateio}
          onClick={() => {
            if (resultadoSelecionado) {
              concluirRateioOcRc(resultadoSelecionado).then((data) => {

              });
            }
          }} />);

    }
    return actions;

  }, [resultadoSelecionado, distribuicaoItemSelecionado, enableBtnsRateio]);

  const btnsNovaLinha = useMemo(() => {
    const actions = [];
    actions.push(
      <Button
        type="link"
        title="Cancelar"
        icon="commons-cancel"
        onClick={() => {
          setEnableBtnsRateio(false);
          setProjetoOrdemInvestimento([] as ProjetoCrfContaContabilCc[]);
          setDisplayWidgetNovaLinha({ display: 'none' });
        }}
      />,
    );

    actions.push(
      <Button
        type="primary"
        title="Adicionar linha selecionada"
        icon="data-add_row"
        disabled={btnAdcionarLinhaSelecionado}
        onClick={() => {
          if (selectionOrdemInvestimento && resultadoSelecionado) {
            adicionarLinhaItemRateavelRequisitadoAno(selectionOrdemInvestimento.crfContaContabilCcId, resultadoSelecionado).then(
              data => {
                AtualizarTablelaContratoAno();
              },
            );
          } else {
            notification.error('Você deve selecionar um Centro de Custo e Conta Contábil');
          }
        }}
      />,
    );

    return actions;
  }, [selectionOrdemInvestimento, resultadoSelecionado, btnAdcionarLinhaSelecionado]);

  const AtualizarTablelaContratoAno = () => {
    getAllRequisitadoAnoOc(resultadoSelecionado).then(data => {
      if (data) {
        const resultContratoAno = data as DistribuicaoRequisitado;
        setDistribuicao(resultContratoAno);
        setResultContratadoAno(resultContratoAno.resultDataTabel);
        if (resultContratoAno.resultDataTabel.length > 0) {
          obterNaratinva(resultContratoAno.resultDataTabel[0].crfContaContabilCcRequisicaoCompraSeqId);
        }
      }
    });
  };

  const obterNaratinva = (crfContaContabilCcRequisicaoCompraSeqId: string) => {
    obterNarativaPorCrfContaContabilCcRequisicaoCompraSeqId(crfContaContabilCcRequisicaoCompraSeqId).then(data => {
      if (data)
        setImputTextoNarativa(data);
    });

  }

  const buscarDistribuicaoItem = () => {
    if (resultadoSelecionado) {
      getAllRequisitadoAnoOc(resultadoSelecionado).then(data => {
        if (data) {
          const resultContratoAno = data as DistribuicaoRequisitado;
          setDistribuicao(resultContratoAno);
          setResultContratadoAno(resultContratoAno.resultDataTabel);
          setDisplayWidgetTabelaDistribuicao({ display: 'block' });
          if (resultContratoAno.resultDataTabel.length > 0) {
            obterNaratinva(resultContratoAno.resultDataTabel[0].crfContaContabilCcRequisicaoCompraSeqId);
          }
        }
      });
    } else {
      notification.error('Você deve selecionar um item');
    }
  };

  const handleChangeImputProjeto = (event: ChangeEvent<HTMLInputElement>) => {
    setImputProjeto(event.target.value);
  };
  const handleChangeImputPacoteOi = (event: ChangeEvent<HTMLInputElement>) => {
    setImputPacoteOi(event.target.value);
  };

  return (
    <SimpleView>
      <GridView noform>
        <FiltrosPcs onSearch={handleFilter} atualizarTela={limparCamposTela} />

        <Widget
          title="RESULTADO"
          span={12}
          style={displayWidgetResultado}
          actions={[
            <Button
              type="primary"
              title="VER DISTRIBUIÇÃO"
              icon="data-database"
              onClick={() => {
                buscarDistribuicaoItem();
              }}
            />,
          ]}>
          <Table
            rowKey="id"
            id={'tabelaDistribuicaoResultRequisitadoOc-crf'}
            columns={columsRequisicaoCompraSeq}
            dataSource={resultPesquisa}
            rowSelection={{
              ...rowSelection,
            }}
          />
        </Widget>



        <Widget
          title="DISTRIBUIÇÃO DO ITEM"
          actions={btnsDistribuicaoItem}
          style={displayWidgetTabelaDistribuicao}>

          <MasterDetailForm initialValues={[]}>
            <Narativa textoNarativa={imputTextoNarativa} />
          </MasterDetailForm>

          <Table
            id={'tabelaDistribuicaoRequisitadoOc'}
            rowKey="crfContaContabilCcRequisicaoCompraSeqId"
            columns={columsDistribuicaoItem}
            dataSource={resultContratadoAno}
            pagination={false}
            rowSelection={{
              ...rowSelectionTableDistribuicao,
            }}
          />

          <Widget
            title="INSERIR NOVAS LINHAS"
            className="inserir-novo-item"
            span={12}
            actions={btnsNovaLinha}
            style={displayWidgetNovaLinha}>
            <MasterDetailForm initialValues={[]}>
              <FormInput label="Nº. Centro de Custo" name="projeto" span={2} allowClear onChange={handleChangeImputProjeto} />
              <FormInput label="Código Conta Contábil" name="pacoteOi" span={2} allowClear onChange={handleChangeImputPacoteOi} />
              <Button
                type="link"
                title="PESQUISAR"
                onClick={() => {
                  if (imputProjeto !== '' || imputPacoteOi !== '') {
                    getAllCrfProjetoContaContabilCc(imputProjeto, imputPacoteOi).then(data => {
                      setProjetoOrdemInvestimento(data);
                      if (data && data.length > 0) {
                        setBtnAdcionarLinhaSelecionada(false);
                      } else {
                        setBtnAdcionarLinhaSelecionada(true);
                      }
                    });
                  } else {
                    notification.error('Deve ser informado o  Centro de Custo ou Código Conta Contábil');
                  }
                }}
              />
            </MasterDetailForm>

            <Table
              rowKey="crfContaContabilCcId"
              columns={columsNovasLinhas}
              dataSource={resultProjetoOrdemInvestimento}
              rowSelection={{
                ...rowSelectionOrdemInvestimento,
              }}
            />
          </Widget>
        </Widget>
      </GridView>
    </SimpleView>
  );
};

export default RequisitadoOc;
